export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7380.e7bae237.jpg";